import axios from 'axios';
import config from '../config/config';
import { detectDeviceLocale } from '../utils/locales';

const API_URL = config.api.baseUrl + config.api.usersEndpoint;

export const register = (
    username,
    email,
    password,
    passwordCheck,
    agreedToTerms,
    confirmedAge,
    aiDataProcessingConsent,
    aiDataProcessingConsentVersion,
    earlyAccessToken = null
) => {
    return axios.post(`${API_URL}/register`, {
        username,
        email,
        password,
        passwordCheck,
        agreedToTerms,
        confirmedAge,
        aiDataProcessingConsent,
        aiDataProcessingConsentVersion,
        earlyAccessToken,
        preferredLocale: detectDeviceLocale(),
    });
};

export const resendVerificationEmail = (email) =>
    axios.post(`${API_URL}/resend-verification`, { email });

export const login = async (email, password, timezone) => {
    const detectedLocale = detectDeviceLocale();
    console.info('[Locale][WebLoginRequest]', {
        email: email?.trim() || null,
        detectedLocale,
    });
    const response = await axios.post(`${API_URL}/login`, {
        email,
        password,
        timezone,
        preferredLocale: detectedLocale,
    });
    console.info('[Locale][WebLoginResponse]', {
        preferredLocale: response?.data?.user?.preferredLocale || null,
    });
    if (response.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data;
};

export const logout = () => {
    localStorage.removeItem('user');
};

export const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem('user'));
};

export const checkSession = async () => {
    const currentUser = getCurrentUser();
    if (!currentUser || !currentUser.token) {
        throw new Error("No token found");
    }

    const response = await axios.get(`${API_URL}/session-check`, {
        headers: {
            'x-auth-token': currentUser.token
        }
    });
    console.info('[Locale][WebSessionCheckResponse]', {
        preferredLocale: response?.data?.user?.preferredLocale || null,
    });

    if (response.data) {
        // The session-check response includes the user object and potentially a new token
        // We update the entire user object in localStorage to keep it fresh
        localStorage.setItem('user', JSON.stringify(response.data));
    }

    return response.data;
};

export const recordAiDataProcessingConsent = async (aiDataProcessingConsentVersion) => {
    const currentUser = getCurrentUser();
    if (!currentUser || !currentUser.token) {
        throw new Error('No token found');
    }

    const response = await axios.post(`${API_URL}/ai-data-processing-consent`, {
        aiDataProcessingConsent: true,
        aiDataProcessingConsentVersion,
    }, {
        headers: {
            'x-auth-token': currentUser.token
        }
    });

    if (response.data?.user) {
        const updatedData = { ...currentUser, user: response.data.user };
        localStorage.setItem('user', JSON.stringify(updatedData));
    }

    return response.data;
};

export const verifyEmail = async (token) => {
    const response = await axios.get(`${API_URL}/verify-email?token=${token}`);
    console.info('[Locale][WebVerifyEmailResponse]', {
        preferredLocale: response?.data?.user?.preferredLocale || null,
    });
    if (response.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data;
};
